import { Box } from "@mui/material";
import { GetExtraWorkAgreementQueryResponse } from "api/generatedApi";
import { EditExtraWorkAgreementInternalNumber } from "./internal-number";
import { UseFormRegister, UseFormGetValues, UseFormSetValue, Control, UseFormWatch } from "react-hook-form";
import { ExtraWorkAgreementFormData } from "../hooks/use-input-validation";
import { EditExtraWorkAgreementNumber } from "./number";
import { EditExtraWorkAgreementSelectType } from "./select-type";
import { Payment } from "./payment";
import { EditExtraWorkAgreementTimeOrPayment } from "./time-or-payment";

interface Props {
  agreement?: GetExtraWorkAgreementQueryResponse;
  disabled: boolean;
  register: UseFormRegister<ExtraWorkAgreementFormData>;
  getValue: UseFormGetValues<ExtraWorkAgreementFormData>;
  setValue: UseFormSetValue<ExtraWorkAgreementFormData>;
  control: Control<ExtraWorkAgreementFormData>;
  watch: UseFormWatch<ExtraWorkAgreementFormData>;
  editPageState: "edit" | "view";

}



export const DetailCard = (props: Props) => {
  const { agreement, disabled, register, getValue, setValue, control, watch, editPageState } = props;

  const displayAgreementNumber = () => {
    if (agreement?.extraWorkAgreementNumber) {
      return true;
    } else if (editPageState === "edit") {
      return true;
    } else {
      return false;
    }
  }

  return (
    <Box display="flex" flexDirection={"column"} gap={3}>
      <Box display="flex" flexDirection={"row"} gap={2} justifyContent={"space-between"}>
        <EditExtraWorkAgreementInternalNumber agreement={agreement} />
        {displayAgreementNumber() && (
          <EditExtraWorkAgreementNumber register={register} getValue={getValue} setValue={setValue} agreement={agreement} disabled={disabled} editPageState={editPageState} />
        )}
      </Box>
      <Box display="flex" flexDirection={"row"} gap={2} justifyContent={"space-between"}>
        <EditExtraWorkAgreementSelectType control={control} agreement={agreement} disabled={disabled} />
        <Payment agreement={agreement} disabled={disabled} />
      </Box>
      <EditExtraWorkAgreementTimeOrPayment setValue={setValue} getValue={getValue} watch={watch}
        register={register} agreement={agreement} disabled={disabled} />
    </Box>

  )
}